import clsx from 'clsx';

import { LoadingPosition } from './LoadingComponent';

interface Props {
  contextClassName?: string;
  modifierClassName?: string;
  text?: string;
  position?: LoadingPosition;
  'data-testid'?: string;
}

const LoadingBar = ({
  contextClassName,
  modifierClassName,
  text,
  position = 'FIXED',
  ...rest
}: Props) => {
  const classNames = clsx(
    'LoadingBar',
    { 'LoadingBar--inline': position === 'INLINE' },
    modifierClassName
  );

  return (
    <div className={contextClassName}>
      <div className={classNames}>
        <div className="LoadingBar-bar" data-testid={rest['data-testid']} />
        {text && <span className="LoadingBar-text">{text}</span>}
      </div>
    </div>
  );
};

export default LoadingBar;
